import { useEffect, useState } from "react";
import api, { fmtDate } from "@/lib/api";
import DateInput from "@/components/DateInput";

const errText = (e, f) => (typeof e?.response?.data?.detail === "string" ? e.response.data.detail : f);

export default function HolidaysConfig() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ date: "", name: "" });
  const [edit, setEdit] = useState(null);
  const [err, setErr] = useState("");
  const load = () => api.get("/public-holidays").then(r => setList(r.data));
  useEffect(() => { load(); }, []);

  async function add() {
    setErr("");
    try { await api.post("/public-holidays", form); setForm({ date: "", name: "" }); load(); } catch (e) { setErr(errText(e, "Couldn't add")); }
  }
  async function save() {
    setErr("");
    try { await api.put(`/public-holidays/${edit.id}`, { date: edit.date, name: edit.name }); setEdit(null); load(); } catch (e) { setErr(errText(e, "Couldn't save")); }
  }
  async function del(h) {
    if (!window.confirm(`Delete ${h.name} (${fmtDate(h.date)})?`)) return;
    await api.delete(`/public-holidays/${h.id}`); load();
  }
  return (
    <div className="card space-y-3" data-testid="holidays-config">
      <h2 className="text-silver">Public holidays</h2>
      <div className="text-xs opacity-60">Shown on the leave calendar, not counted as leave days, and skipped by the Monday timesheet reminder. Wellington region (Masterton).</div>
      <div className="flex gap-2 items-end flex-wrap">
        <label className="text-sm">Date<DateInput className="input" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} data-testid="hol-new-date" /></label>
        <label className="text-sm flex-1 min-w-[12rem]">Name<input className="input w-full" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} data-testid="hol-new-name" /></label>
        <button className="btn-silver" disabled={!form.date || !form.name.trim()} onClick={add} data-testid="hol-add">Add holiday</button>
      </div>
      {err && <div className="text-sm text-red-400" data-testid="hol-error">{err}</div>}
      <table className="table"><thead><tr><th>Date</th><th>Day</th><th>Name</th><th></th></tr></thead>
        <tbody>{list.map(h => edit?.id === h.id ? (
          <tr key={h.id} data-testid={`hol-row-${h.date}`}>
            <td><DateInput className="input" value={edit.date} onChange={e => setEdit({ ...edit, date: e.target.value })} data-testid="hol-edit-date" /></td><td />
            <td><input className="input w-full" value={edit.name} onChange={e => setEdit({ ...edit, name: e.target.value })} data-testid="hol-edit-name" /></td>
            <td className="space-x-2 whitespace-nowrap"><button className="hub-link text-xs" onClick={save} data-testid="hol-edit-save">Save</button><button className="hub-link text-xs" onClick={() => setEdit(null)}>Cancel</button></td>
          </tr>
        ) : (
          <tr key={h.id} data-testid={`hol-row-${h.date}`}>
            <td>{fmtDate(h.date)}</td><td className="text-xs opacity-70">{new Date(h.date + "T00:00:00").toLocaleDateString("en-NZ", { weekday: "short" })}</td><td>{h.name}</td>
            <td className="space-x-2 whitespace-nowrap"><button className="hub-link text-xs" onClick={() => setEdit(h)} data-testid={`hol-edit-${h.date}`}>Edit</button><button className="hub-link text-xs text-red-400" onClick={() => del(h)} data-testid={`hol-del-${h.date}`}>Delete</button></td>
          </tr>
        ))}</tbody></table>
    </div>
  );
}
